import { SelectProps } from "antd";
import { useTranslate } from "#src/hooks";

// Booleans that default to true and save unconditionally. Loaded/saved
// generically per settings object; rendered by hand in their sections.
export const BOOLEAN_FIELDS_MEDIA_SETTINGS = [
  "video_sourcing_enabled",
  "image_sourcing_enabled",
  "include_document_animations",
  "generate_images_for_slides",
  "generate_brandkit",
] as const;

export const BOOLEAN_FIELDS_STORYBOARD_SETTINGS = [
  "generate_emotions",
] as const;

export const buildBooleanSelectOptions = (
  t: ReturnType<typeof useTranslate>
): SelectProps["options"] => [
  {
    label: t("pages.playbooks.sections.advanced.optionEnabled"),
    value: "enabled",
  },
  {
    label: t("pages.playbooks.sections.advanced.optionDisabled"),
    value: "disabled",
  },
];

// Auto / Enabled / Disabled — the full BooleanOption set. Shared by
// transitions and auto-select music.
export const buildBooleanOptions = (
  t: ReturnType<typeof useTranslate>
): SelectProps["options"] => [
  {
    label: t("pages.playbooks.sections.advanced.optionAuto"),
    value: "auto",
  },
  ...(buildBooleanSelectOptions(t) || []),
];

export const buildStoryboardGenerationModeOptions = (
  t: ReturnType<typeof useTranslate>
): SelectProps["options"] => [
  {
    label: t(
      "pages.playbooks.sections.advanced.storyboardGenerationModeStandard"
    ),
    value: "Standard",
  },
  {
    label: t(
      "pages.playbooks.sections.advanced.storyboardGenerationModeTranslate"
    ),
    value: "Translate",
  },
  {
    label: t(
      "pages.playbooks.sections.advanced.storyboardGenerationModeTranscript"
    ),
    value: "Transcript",
  },
];

export const buildChatModeOptions = (
  t: ReturnType<typeof useTranslate>
): SelectProps["options"] => [
  {
    label: t("pages.playbooks.sections.advanced.chatModeFullChat"),
    value: "FullChat",
  },
  {
    label: t("pages.playbooks.sections.advanced.chatModeSourcesOnly"),
    value: "SourcesOnly",
  },
  {
    label: t("pages.playbooks.sections.advanced.chatModeDisabled"),
    value: "Disabled",
  },
];
